// Prispôsobí font-size elementov s [data-fit-text] tak, aby text vyplnil cieľovú šírku:
//   data-fit-text          → 100 % šírky rodiča
//   data-fit-text="0.6"    → 60 % šírky rodiča
//   data-fit-text="40vw"   → 40 % šírky okna
const BASE_SIZE = 100

// varianty podľa šírky okna: data-fit-text-tablet (≤ 991px), data-fit-text-mobile (≤ 576px)
function fitValue( el ) {
    const width = window.innerWidth

    if ( width <= 576 && el.dataset.fitTextMobile ) return el.dataset.fitTextMobile
    if ( width <= 991 && ( el.dataset.fitTextTablet || el.dataset.fitTextMobile ) ) return el.dataset.fitTextTablet || el.dataset.fitTextMobile

    return el.dataset.fitText || ""
}

function targetWidth( el ) {
    const value = fitValue( el ).trim()

    if ( value.endsWith( "vw" ) ) {
        return window.innerWidth * parseFloat( value ) / 100
    }

    // obsahová šírka rodiča (clientWidth zahŕňa padding, ten treba odpočítať)
    const parent = el.parentElement
    const style = window.getComputedStyle( parent )
    const contentWidth = parent.clientWidth - parseFloat( style.paddingLeft ) - parseFloat( style.paddingRight )

    const ratio = parseFloat( value )
    return contentWidth * ( isNaN( ratio ) ? 1 : ratio )
}

// data-fit-text-wrap="mobile|tablet|always": text sa smie zalomiť, písmo sa počíta
// podľa najdlhšieho slova (meranie cez canvas s fontom elementu)
function wrapActive( el ) {
    const mode = el.dataset.fitTextWrap

    if ( mode === undefined ) return false
    if ( mode === "mobile" ) return window.innerWidth <= 576
    if ( mode === "tablet" ) return window.innerWidth <= 991

    return true
}

const canvas = document.createElement( "canvas" )

function longestWordWidth( el ) {
    const style = window.getComputedStyle( el )
    const ctx = canvas.getContext( "2d" )
    let text = el.textContent.trim()

    if ( style.textTransform === "uppercase" ) text = text.toUpperCase()

    ctx.font = style.fontStyle + " " + style.fontWeight + " " + BASE_SIZE + "px " + style.fontFamily

    return text.split( /\s+/ ).reduce( function( max, word ) {
        return Math.max( max, ctx.measureText( word ).width )
    }, 0 )
}

function fitText( el ) {
    const width = targetWidth( el )

    if ( !width ) return

    el.style.fontSize = BASE_SIZE + "px"
    const textWidth = wrapActive( el ) ? longestWordWidth( el ) : el.scrollWidth

    if ( !textWidth ) return

    el.style.fontSize = ( BASE_SIZE * width / textWidth ) + "px"
}

function fitAll() {
    document.querySelectorAll( "[data-fit-text]" ).forEach( fitText )
}

$(document).ready( function() {
    fitAll()

    if ( document.fonts && document.fonts.ready ) {
        document.fonts.ready.then( fitAll )
    }

    let resizeTimer

    $( window ).on( "resize", function() {
        clearTimeout( resizeTimer )
        resizeTimer = setTimeout( fitAll, 100 )
    })
})
